// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_n4-0";
export var animationContainer = "_n4-1";
export var itemPrice = "_n4-a";
export var itemizedContent = "_n4-9";
export var itemizedHeader = "_n4-7";
export var itemizedRow = "_n4-8";
export var itemizedSection = "_n4-6";
export var modalContent = "_n4-2";
export var orderName = "_n4-3";
export var refundOption = "_n4-4";
export var refundOptionsContainer = "_n4-5";
export var shippingLabel = "_n4-b";
export var totalRow = "_n4-c";